import { useState } from "react";
import { IoCalendarOutline } from "react-icons/io5";

function DateRangeFilter({ filters, setFilters }) {
  const [isOpen, setIsOpen] = useState(false);

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";
    try {
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    } catch (e) {
      return "";
    }
  };

  const hasActiveFilters = filters.sprint_start_date || filters.sprint_end_date;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border rounded-md transition-colors
          ${hasActiveFilters ? "bg-blue-50 text-blue-600 border-blue-200" : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"}`}>
        <IoCalendarOutline className="h-4 w-4" />
        Sprint Date Range
        {hasActiveFilters && <span className="ml-1 w-2 h-2 bg-blue-500 rounded-full"></span>}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full mt-1 z-20 p-4 bg-white rounded-md shadow-xl border border-gray-200 w-64 space-y-3">
            <h5 className="text-sm font-semibold text-gray-700 uppercase mb-3">Select Sprint Date Range</h5>

            <div>
              <label htmlFor="sprintStartDate" className="block text-xs font-medium text-gray-600 mb-1">
                Start Date:
              </label>
              <input
                type="date"
                id="sprintStartDate"
                name="sprintStartDate"
                value={formatDateToYYYYMMDD(filters.sprint_start_date)}
                onChange={(e) =>
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    sprint_start_date: e.target.value,
                  }))
                }
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div>
              <label htmlFor="sprintEndDate" className="block text-xs font-medium text-gray-600 mb-1">
                End Date:
              </label>
              <input
                type="date"
                id="sprintEndDate"
                name="sprintEndDate"
                value={formatDateToYYYYMMDD(filters.sprint_end_date)}
                onChange={(e) =>
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    sprint_end_date: e.target.value,
                  }))
                }
                min={formatDateToYYYYMMDD(filters.sprint_start_date)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>

            <div className="flex gap-2 pt-2">
              <button
                onClick={() => {
                  setFilters((prevFilters) => ({
                    ...prevFilters,
                    sprint_start_date: null,
                    sprint_end_date: null,
                  }));
                }}
                className="flex-1 text-center px-3 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                Clear
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="flex-1 text-center px-3 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                Done
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DateRangeFilter;
